<template>
  <main id="container" class="page-container page-category">
    <div class="container">
      <div class="category-wrap">
        <h2 class="search-result-tit">통합검색</h2>
        <div class="serch-result-box">
           <div class="in-search-box">
            <div class="in-search-area">
              <input
                type="text"
                class="in-search-input"
                v-model="searchName"
                placeholder="제품명을 입력하세요."
                @keyup.enter="applyFiltersAndFetchAll()"
              />
              <button
                type="button"
                class="in-search-button"
                @click="applyFiltersAndFetchAll()"
              >
                <i class="icon">
                  <img src="@/assets/img/common/ico-search-result-btn.svg" alt="검색" />
                </i>
              </button>
            </div>
          </div>
        </div>
        <div class="result-txt-wrap">
          <div class="result-txt">
            <b>'{{ searchName }}'</b>의 키워드로 총 <b>{{ totalCount }}</b>건이 검색되었습니다.
          </div>
        </div>

        
        <div class="products-list" v-if="items && items.length > 0">
          <products-item
            v-for="(item, index) in items"
            :key="item.id"
            :id="item.id"
            :item="item"
            :num="index"
            parent-click-evnt-nm="modalClicked"
            @modalClicked="handleClickModal"
          />
        </div>
        <div class="products-list" v-else>
          <div class="w-100">
            <div class="no-data-msg">검색 결과가 없습니다.</div>
            <div class="no-data-info">
              <ul>
                <li>-단어의 철자가 정확한지 확인해 보세요.</li>
                <li>-한글을 영어로 혹은 영어를 한글로 입력했는지 확인해 보세요.</li>
                <li>-검색어의 단어 수를 줄이거나 보다 일반적인 검색어로 다시 검색해 보세요.</li>
                <li>-두 단어 이상의 검색어인 경우, 띄어쓰기를 확인해 보세요.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="btn-more-cont-wrap" v-if="items.length < totalCount">
        <button type="button" class="btn-more-cont" @click="loadMore">
          <span>상품 더보기 ({{ items.length }}/{{ totalCount }})</span>
        </button>
      </div>
    </div>

    <!-- Shared Modal -->
    <products-modal
      :visible="visibleModal"
      @closeModal="handleCloseModal"
      :item="modalItem"
      :evnt-strt-dt="evntStrtDt"
      :evnt-end-dt="evntEndDt"
      parent-click-evnt-nm="clickEvnt"
      @clickEvnt="handleClickModalEvnt"
    />
  </main>
</template>

<script>
import { mapGetters } from 'vuex';
import { ACT_GET_DHFESTA_EVENT_MNG, ACT_UPDATE_CAMPN_MANPRD_FAVR, ACT_UPDATE_CAMPN_MANPRD_STAR } from "@/store/_act_consts";
import { lengthCheck, getItem, timestampToDateFormat } from "@/assets/js/utils";
import ProductsItem from '@/components/content/ProductsItem.vue';
import ProductsModal from "@/components/content/ProductsModal";

export default {
  name: "SearchResultPage",
  components: {
    ProductsItem,
    ProductsModal
  },
  data() {
    return {
      searchName: "",
      manprdAllList: [],
      items: [],
      pageNo: 1,
      pageSize: 12,
      totalCount: 0,
      visibleModal: false,
      modalItem: null,
      evntStrtDt: "",
      evntEndDt: ""
    };
  },
  created() {
    // URL에서 검색어 읽어오기 (검색창에 검색어 유지)
    this.searchName = this.$route.query.q || "";

    //세션스토리지에 저장된 상품리스트 가져오기
    const savedData = sessionStorage.getItem('search_results');

    if (savedData) {
      this.manprdAllList = JSON.parse(savedData);
      this.totalCount = this.manprdAllList.length;

      this.getManprdList(1);
    } else {
      // 만약 세션에 검색 결과가 없다면 전체 리스트에서 필터링 시도
      this.applyFiltersAndFetchAll();
    }
    this.getEvntMng();
  },
  computed: {
    ...mapGetters("common", ["isMobile", "commonCode", "campn"]),
    ...mapGetters("auth", ["session", "isAuth"]),
    queries() {
      return { q: this.searchName};
    }
  },
  methods: {
    handleSearch() {
      if (!this.searchName) return;
      this.applyFiltersAndFetchAll();
    },
    // 팝업 max-height
    setLayerHeight() {
      const layer = document.querySelector('.layer-popup-container');
      if (!layer) return;

      const inner = layer.querySelector('.layer-popup');
      if (!inner) return;

      const style = getComputedStyle(inner);
      const pdt = parseFloat(style.paddingTop) || 0;
      const pdb = parseFloat(style.paddingBottom) || 0;

      const footer = layer.querySelector('.popup-footer');
      const header = inner.querySelector('.popup-header');

      const bottomFixedHeight = footer ? footer.offsetHeight : 0;
      const headerHeight = header ? header.offsetHeight : 0;

      const popupBody = inner.querySelector('.popup-body');
      if (!popupBody) return;

      const maxHeight =
        window.innerWidth > 800
          ? layer.offsetHeight * 0.7 - (pdt + pdb) - bottomFixedHeight - headerHeight
          : layer.offsetHeight * 0.9 - (pdt + pdb) - bottomFixedHeight - headerHeight;

      popupBody.style.maxHeight = `${maxHeight}px`;
    },
    // 팝업 max-height 리사이즈
    setResizeEvent() {
      window.removeEventListener("resize", this.resizeHandler);

      this.resizeHandler = () => {
        this.setLayerHeight();
      };

      window.addEventListener("resize", this.resizeHandler);

      this.$nextTick(() => {
        setTimeout(() => {
          this.setLayerHeight();
        }, 0);
      });
    },
    async getEvntMng() {
      this.evntStrtDt = "";
      this.evntEndDt = "";

      if(!this.campn) return;

      await this.$store
        .dispatch(`event/${ACT_GET_DHFESTA_EVENT_MNG}`, {
          campnId: this.campn.campnId,
          evntTyp: "20",
        })
        .then((res) => {
          if (lengthCheck(res)) {
            const item = getItem(res);
            this.evntStrtDt =
              timestampToDateFormat(Number(item.evntStrtDt), "yyyy-MM-dd") +
              " 00:00";
            this.evntEndDt =
              timestampToDateFormat(Number(item.evntEndDt), "yyyy-MM-dd") +
              " 00:00";
          } else {
            this.evntStrtDt = this.campn.strtDt;
            this.evntEndDt = this.campn.endDt;
          }
        });
    },
    handleCloseModal() {
      this.visibleModal = false;

      // 모바일 크롬에서 body에 overflow
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';

      // DOM 렌더 후 스크롤 복구
      this.$nextTick(() => {
        window.scrollTo(0, this.layerScrollTop);
        window.removeEventListener("resize", this.resizeHandler);
      });
    },
    handleClickModalEvnt(type, score) {
      // 필요 시 처리
    },
    handleClickModal(id) {
      this.modalItem = this.items.find(i => i.id === id);
      this.visibleModal = true;

      this.layerScrollTop = window.scrollY;
      // 모바일 크롬에서 body에 스크롤 생기는 이슈 해결
        document.body.style.position = 'fixed';
        document.body.style.top = `-${this.layerScrollTop}px`;
        document.body.style.width = '100%';

        this.$nextTick(() => {
          requestAnimationFrame(() => {
            const header = document.querySelector('.header');
            if (header && this.layerScrollTop > 0) {
              header.classList.add('hd-bg');
            }
            this.setResizeEvent();
          });
        });
    },
    loadMore() {
      this.pageNo++;
      this.getManprdList(this.pageNo, true);
    },
    // 상품리스트 페이지네이션 처리
    getManprdList(pageNo, isAppend = false) {
        
        this.pageNo = pageNo || 1;
        const start = (this.pageNo - 1) * this.pageSize;
        const end = start + this.pageSize;
        const nextItems = this.manprdAllList.slice(start, end);

        if (isAppend) {
          this.items = [...this.items, ...nextItems];
        } else {
          this.items = nextItems;
          window.scrollTo(0, 0);
        }
    },
    // 검색시 호출되는 함수
    applyFiltersAndFetchAll() {
        const dataTemp = sessionStorage.getItem('manprdAllList');

        if (!dataTemp) return;

        // 원본을 임시변수 originList에 저장
        const originList = JSON.parse(dataTemp);

        // 원본에서 검색어를 포함하는 상품만 필터링하여 manprdAllList에 저장
        const keyword = this.searchName.toLowerCase();
        this.manprdAllList = originList.filter((m) =>
            m.title.toLowerCase().includes(keyword) || 
            (m.company && m.company.toLowerCase().includes(keyword))
          );
        
        // 전체 개수를 갱신 (페이징을 새로 하기 위해)
        this.totalCount = this.manprdAllList.length;

        // 세션에 필터링된 결과 저장
        sessionStorage.setItem('search_results', JSON.stringify(this.manprdAllList));

        this.getManprdList(1);
    }
  }
};
</script>

<style scoped>
#container {
  padding-bottom:100px;
}
.search-result-tit {
  padding:32px 0 24px;
  border-bottom:2px solid #2567B0;
  font-family: "Pretendard";
  font-size:36px;
}
.in-search-box {
  display:flex;
  justify-content: center;
  margin:24px 0 64px;
}
.in-search-area {
  display:flex;
  max-width:752px;
  width:100%;
}
.in-search-input {
  padding:0 16px;
  border: 2px solid #075D5D;
  border-radius:8px;
  width:100%;
  height:72px;
  font-size:25px;
  color:#555;
  background:#fff;
}
.in-search-button {
  border:2px solid #075D5D;
  border-radius:8px;
  min-width:72px;
  height:72px;
  background:#075D5D;
}
.no-data-msg {
  padding: 40px 0 50px;
  width: 100%;
  text-align: center;
  line-height:1.5;
  font-size:21px;
  color:#1d1d1d;
  font-weight:700;
}
.no-data-info {
  padding:24px 30px;
  border-top: 2px solid #097C7C;
  border-bottom: 1px solid #CCC;
  width:100%;
}
.no-data-info li {
  position:relative;
  padding-left:24px;
  line-height:1.5;
  font-size:15px;
  color:#555;
}
.no-data-info li:before {
  position:absolute;
  left: 10px;
  top: 10px;
  content:"";
  border-radius:50%;
  width:3px;
  height:3px;
  background:#555;
}
.result-txt-wrap {
  margin-bottom:30px;
}
.result-txt {
  line-height: 150%;
  font-size: 17px;
  color: #555;
}
.result-txt b {
  color:#FF3600;
  font-weight:700;
}
@media(max-width: 1024px) {
  .in-search-input {
    height:60px;
    font-size:20px;
  }
  .in-search-button {
    min-width:60px;
    height:60px;
  }
  .in-search-button img {
    width:32px;
  }
  .products-list .products-item {
    width:calc(33.333% - 14px)
  }
}
@media(max-width: 800px) {
  .in-search-box {
    margin-bottom:40px;
  }
  .in-search-input {
    height:50px;
    font-size:15px;
  }
  .in-search-button {
    min-width:50px;
    height:50px;
  }
  .in-search-button img {
    width:26px;
  }
  .result-txt {
    font-size: 15px;
  }
  .products-list .products-item {
    width: calc(50% - 5px);
  }
}
</style>

